exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.top {\n  display: flex;\n  position: relative;\n  background: #009688;\n}\n.menu {\n  display: flex;\n  flex-grow: 1;\n  justify-content: flex-end;\n}\n.menu-item a {\n  color: #ffffff;\n  padding: 1.5rem 0rem 1.5rem 0rem;\n  display: block;\n  cursor: pointer;\n}\n.menu-item a:hover {\n  text-decoration: none;\n}\n.dropdown_menu {\n  position: absolute;\n  z-index: 1;\n  background: #353a40;\n}\n.submenu-item a {\n  padding: 0.5rem 1.5rem 0.5rem 1.5rem;\n  display: block;\n}\n.business_logo img {\n  height: 25px;\n  margin: 15px 15px 0px 15px;\n  cursor: pointer;\n}\n", ""]);

// exports
